var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarGathering(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25576 4.28372L20.4186 12.6558C20.7699 12.9193 20.9767 13.3329 20.9767 13.7721C20.9767 14.2113 20.7699 14.6249 20.4186 14.8884L9.25576 23.2605C8.83227 23.5781 8.26552 23.6287 7.79245 23.3912C7.31937 23.1537 7.02143 22.6689 7.0232 22.1395V5.39535C7.02496 4.86767 7.32424 4.38612 7.79661 4.15092C8.26897 3.91572 8.83361 3.96711 9.25576 4.28372Z",
    fill: "#1D1D26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarGathering);
export default __webpack_public_path__ + "static/media/SidebarGathering.b305c5ec2abbd0a4209622fca56c7f59.svg";
export { ForwardRef as ReactComponent };